var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { Spinner } from '../../config/common';
import API from '../../util/ApiUtil';
import CountryUtil from '../../util/CountryUtil';
import PersonalCodeValidator from '../../util/PersonalCodeValidator';
export default class PersonDataRegistryStore {
    constructor(rootStore) {
        Object.defineProperty(this, "personalCodeError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "personMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "personStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITIALIZED'
        });
        Object.defineProperty(this, "PERSON_FIELDS_TO_REFRESH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['firstName', 'lastName']
        });
        Object.defineProperty(this, "spinnerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fetchPersonData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (personalCode, personalCodeCountryCode) => {
                try {
                    this.validatePersonalCode(personalCode, personalCodeCountryCode);
                    if (!this.shouldLoadFromCache(personalCode, personalCodeCountryCode)) {
                        if (this.shouldFetchPersonData(personalCode)) {
                            await this.fetchPerson(personalCode, personalCodeCountryCode);
                        }
                        if (this.shouldFetchPopulationRegistry(personalCode, personalCodeCountryCode)) {
                            await this.fetchPopRegistry(personalCode);
                        }
                    }
                }
                catch (_a) {
                    this.personStatus = 'ERROR';
                }
                finally {
                    this.personStatus = 'FETCHED';
                    this.spinnerStore.hide(Spinner.ADD_MANDATE_MODAL);
                }
            }
        });
        Object.defineProperty(this, "handlePersonQuerySuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (person) => {
                const personKey = person.personalCodeCountryCode + person.personalCode;
                if (this.personMap.has(personKey)) {
                    this.PERSON_FIELDS_TO_REFRESH.forEach((field) => (this.personMap.get(personKey)[field] = person[field]));
                }
                else {
                    this.personMap.set(personKey, person);
                }
            }
        });
        makeObservable(this);
        this.spinnerStore = rootStore.spinnerStore;
    }
    validatePersonalCode(personalCode, personalCodeCountryCode) {
        this.personalCodeError = null;
        if (CountryUtil.isEstonia(personalCodeCountryCode)) {
            this.personalCodeError = PersonalCodeValidator.validatePersonalCode(personalCode).error;
        }
    }
    get isPersonalCodeValid() {
        return !this.personalCodeError;
    }
    shouldFetchPersonData(personalCode) {
        return !!personalCode && !this.personalCodeError;
    }
    shouldFetchPopulationRegistry(personalCode, personalCodeCountryCode) {
        return this.shouldFetchPersonData(personalCode) && CountryUtil.isEstonia(personalCodeCountryCode);
    }
    shouldLoadFromCache(personalCode, personalCodeCountryCode) {
        return this.personMap.has(personalCodeCountryCode + personalCode);
    }
    async fetchPopRegistry(personalCode) {
        this.spinnerStore.show(Spinner.ADD_MANDATE_MODAL);
        this.personStatus = 'FETCHING';
        const populationRegistryDataResponse = await API.get(`/person/population-registry-persons/${personalCode}`);
        populationRegistryDataResponse.data.personalCodeCountryCode = 'EE';
        this.handlePersonQuerySuccess(populationRegistryDataResponse.data);
    }
    async fetchPerson(personalCode, personalCodeCountryCode) {
        this.spinnerStore.show(Spinner.ADD_MANDATE_MODAL);
        this.personStatus = 'FETCHING';
        const personDataResponse = await API.get(`/person?personal-code=${personalCode}&personal-code-country-code=${personalCodeCountryCode}`);
        this.handlePersonQuerySuccess(personDataResponse.data);
    }
}
__decorate([
    observable
], PersonDataRegistryStore.prototype, "personalCodeError", void 0);
__decorate([
    observable
], PersonDataRegistryStore.prototype, "personMap", void 0);
__decorate([
    observable
], PersonDataRegistryStore.prototype, "personStatus", void 0);
__decorate([
    action.bound
], PersonDataRegistryStore.prototype, "validatePersonalCode", null);
__decorate([
    computed
], PersonDataRegistryStore.prototype, "isPersonalCodeValid", null);
__decorate([
    action.bound
], PersonDataRegistryStore.prototype, "fetchPersonData", void 0);
__decorate([
    action.bound
], PersonDataRegistryStore.prototype, "handlePersonQuerySuccess", void 0);
